<advanced-filter (onSubmit)="applyFilter()" *ngIf="isCoLogin()"></advanced-filter>
<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="Failure Page ({{totalCount}})" subheading1="{{subheading1}}" subheading2="{{subheading2}}" *ngIf="showFailureDataTable">


<wl-date-input (dateRangeSelected)="onDateRangeSelected($event)" *ngIf="!isCoLogin()"></wl-date-input>
  <span *ngIf="showSelectedDate && !isCoLogin()" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;<img src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px" (click)="closeButtonClick()">
  </span>

  <wl-search-input (searchValueChanged)="onSearch($event)" [ngClass]="{'search': isCoLogin()}"></wl-search-input>
  <br>

  <p *ngIf="noUserFound" class="m-100px text-center font-size-15em">{{noUserFound}}</p>

  <div *ngIf="!noUserFound" child-container class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Cust Id</th>
          <th>Loan Reference Number<br>
          <th  class="w-22pct">Name of Applicant <br>
          <th>Mobile Number<br>
          <th>Failure reason<br>
          <th>Date of Failure <br>
            <th *ngIf="roleId == 1">Zone</th>
            <th *ngIf="roleId == 1 || roleId == 21 || roleId == 2">RO</th>
            <th *ngIf="roleId == 1 || roleId == 21 || roleId == 2 || roleId == 3 || roleId== 31" >Branch</th>
          <th *ngIf="roleId == 1 || roleId == 21 || roleId == 2 || roleId == 3 || roleId== 31">Remarks</th>

        </tr>
      </thead>

      <tbody>
        <tr  *ngFor="let user of allUsers;let i = index;" >
          <td class="vertical-align-middle">
            <p>{{10 *(pageId-1)+i+1}}</p>   
          </td>
          <td class="vertical-align-middle">
            <p>{{(user.custId)? user.custId : ""}}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{user?.ubi_reference_no?user?.ubi_reference_no: 'Loan Reference Number not available'  }}</p>
          </td>
          <td class="vertical-align-middle">

            <p>{{
              (user?.profile?.first_name) ? user.profile.first_name : ""
            }}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{(user?.profile?.mobileNo) ? user.profile.mobileNo : 
              user?.aadhar_details?.mobile_number ? user.aadhar_details.mobile_number:
              user?.mobile_no ? user.mobile_no : "" }}</p>
          </td>
          <td class="vertical-align-middle">
            <p >

                {{
                  user && user.failureReason?user.failureReason:"Failure reason not available"
                }}

            </p>
          </td>
          <td class="vertical-align-middle">
            <p >
              {{
                user && user.appStatus && user.appStatus != "failure"?
                  user && user.newFailureArray && 
                  user.newFailureArray[0]  && 
                  user?.newFailureArray[0]?.date && 
                  user?.newFailureArray[0]?.date?user.newFailureArray[0].date:"Failure date not available"
                : user && user.modified_date ? (user.modified_date ) :"Failure date not available"
              }}

            </p>
          </td>
          <td class="vertical-align-middle" *ngIf="roleId == 1">
            <p>{{user?.zone_name}}</p>
          </td>
          <td class="vertical-align-middle" *ngIf="roleId == 1 || roleId == 21 || roleId == 2">
            <p>{{user?.ro_name}}</p>
          </td>
          <td class="vertical-align-middle" *ngIf="roleId == 1 || roleId == 21 || roleId == 2 || roleId == 3 || roleId== 31">
            <p>{{user?.branch_name}}</p>
          </td>
          <td class="vertical-align-middle" *ngIf="roleId == 1 || roleId == 21 || roleId == 2 || roleId == 3 || roleId== 31">
            <p>{{user?.recordRemarks ? user?.recordRemarks :
              user?.namePercentageCombined ? user?.namePercentageCombined : ""
            }}</p>
          </td>

        </tr>
      </tbody>

    </table>
  </div>

  <nav class="flex-center" *ngIf="totalPage>1 && !this.noUserFound" aria-label="Page navigation example">
    <ul class="pagination">
      <!-- limit - 10 -->
      <li *ngIf="page>3"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">Previous</a></li>
      <li *ngIf="page>2"><a (click)="getAllUsersPage(filter,roleId,offset - 20,10,page - 2)">{{page - 2}}</a></li>
      <li *ngIf="page>1"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">{{page - 1}}</a></li>
      <li class="page-item active"><a (click)="getAllUsersPage(filter,roleId,offset,10,page)">{{page}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">{{page + 1}}</a></li>
      <li *ngIf="page+1<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 20,10,page + 2)">{{page + 2}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">Next</a></li>
    </ul>
  </nav>



</wl-card>




<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />

